import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

interface UseCopyToClipboard {
  copyToClipboard: (value: string | undefined) => Promise<void>
}
/**
 * return a function to copy string value to clipboard
 */
export const useCopyToClipboard = (): UseCopyToClipboard => {
  const { enqueueSuccessStack, enqueueErrorStack } = useSnackbar()
  const { t } = useCustomTranslation()

  const copyToClipboard = async (value: string | undefined): Promise<void> => {
    /* check clipboard is supported */
    if (!navigator.clipboard) {
      enqueueErrorStack(t('common.failed-to-copy-to-clipboard'))
      return
    }

    /* check value is not empty */
    if (!value || value.trim() === '') {
      enqueueErrorStack(t('common.noData'))
      return
    }

    try {
      const textToCopy = value
      await navigator.clipboard.writeText(textToCopy)
      enqueueSuccessStack(t('common.copied-to-clipboard'))
    } catch (error) {
      enqueueErrorStack(t('common.failed-to-copy-to-clipboard'))
    }
  }

  return { copyToClipboard }
}
